var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoalLink({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 608.838,
    height: 800.065,
    viewBox: "0 0 608.838 800.065",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-445.783 -149.051)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(445.783 149.051)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M661.092,267.313h-4.353V148.155a68.963,68.963,0,0,0-68.963-68.962H335.328a68.963,68.963,0,0,0-68.963,68.962v653.7a68.963,68.963,0,0,0,68.963,68.962H587.777a68.963,68.963,0,0,0,68.963-68.963V352.13h4.352Z",
    transform: "translate(-266.365 -79.193)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.025,95.686H556.073a24.468,24.468,0,0,1-22.654,33.71H388.787a24.468,24.468,0,0,1-22.655-33.71H335.355a51.5,51.5,0,0,0-51.5,51.5V799.932a51.5,51.5,0,0,0,51.5,51.5H589.015a51.5,51.5,0,0,0,51.5-51.5V147.188a51.5,51.5,0,0,0-51.491-51.5Z",
    transform: "translate(-264.822 -77.743)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 131.272,
    cy: 131.272,
    r: 131.272,
    transform: "translate(511.875 384.355)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 262.544,
    height: 45.008,
    rx: 12,
    transform: "translate(511.623 269.023)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.254,
    cy: 26.254,
    r: 26.254,
    transform: "translate(511.623 733.164)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.254,
    cy: 26.254,
    r: 26.254,
    transform: "translate(721.658 733.164)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.254,
    cy: 26.254,
    r: 26.254,
    transform: "translate(581.947 733.164)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.254,
    cy: 26.254,
    r: 26.254,
    transform: "translate(651.334 733.164)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.387,588.158V569.624a53.657,53.657,0,0,0-19.653-41.849c-9.414-7.59-23.048-13.266-42.581-12l7.441-29.764-64.263,43.969,62.91,43.969-6.426-28.073S243.05,538.439,266.387,588.158Z",
    transform: "translate(427.597 -21.457)",
    fill: "#7C3AED"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(526.625 748.167)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.253,3A6.251,6.251,0,0,1,25.5,9.251v10A6.251,6.251,0,0,1,19.253,25.5h-10A6.251,6.251,0,0,1,3,19.253v-10A6.251,6.251,0,0,1,9.251,3Zm-5,6.251A5,5,0,0,0,9.257,14l-.006.25a5,5,0,1,0,5-5m5.625-1.875a1.25,1.25,0,0,0-1.241,1.1l-.009.159a1.25,1.25,0,0,0,2.492.146l.009-.159a1.25,1.25,0,0,0-1.25-1.25",
    transform: "translate(-3 -3)",
    fill: "#090814"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(596.949 748.167)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.252,
    cy: 11.252,
    r: 11.252,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.171.822H1.49L9.231,11.9h1.682ZM0,0H3.7L6.9,4.664,10.913,0h1.095L7.387,5.371l5.025,7.314h-3.7L5.332,7.76,1.095,12.685H0L4.847,7.054Z",
    transform: "translate(5.055 4.959)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M707.313,383.01H688.533a1.835,1.835,0,0,0-1.923,1.752v18.82a1.98,1.98,0,0,0,1.923,1.928h18.775a1.88,1.88,0,0,0,1.8-1.928v-18.82a1.725,1.725,0,0,0-1.8-1.752Zm-13.726,18.756h-3.224V391.743h3.224Zm-1.5-11.546h-.023a1.753,1.753,0,1,1,.023,0Zm13.283,11.545h-3.224v-5.48c0-1.313-.469-2.21-1.636-2.21a1.762,1.762,0,0,0-1.653,1.19,2.168,2.168,0,0,0-.112.791v5.708h-3.224V391.743h3.224v1.395a3.264,3.264,0,0,1,2.907-1.63c2.116,0,3.717,1.394,3.718,4.4Z",
    transform: "translate(-20.274 365.159)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(736.66 750.417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5,7.535v10.65a3.376,3.376,0,0,1-3.178,3.37l-.2.006H5.376a3.376,3.376,0,0,1-3.37-3.178L2,18.185V7.535L12.627,14.62l.131.074a1.125,1.125,0,0,0,.988,0l.131-.074L24.5,7.535Z",
    transform: "translate(-2 -3.557)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.073,4a3.371,3.371,0,0,1,2.875,1.606L13.2,12.773,2.445,5.606a3.374,3.374,0,0,1,2.649-1.6L5.32,4Z",
    transform: "translate(-1.944 -4)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(784.964 408.234)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.479 77.361)",
    fill: "#9f616a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 32.35640335083008 25.78230667114258 L 3.902086019515991 25.78230667114258 L 0.5707792043685913 3.835296869277954 L 21.9597053527832 0.9932736158370972 L 32.35640335083008 25.78230667114258 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21.64651107788086 1.539289474487305 L 1.141559600830078 4.263856887817383 L 4.33192253112793 25.28230667114258 L 31.60449981689453 25.28230667114258 L 21.64651107788086 1.539289474487305 M 22.27290153503418 0.4472675323486328 L 33.10830307006836 26.28230667114258 L 3.472251892089844 26.28230667114258 L 0 3.406747817993164 L 22.27290153503418 0.4472675323486328 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M806.516,494.028a9.429,9.429,0,0,0,2.237-14.284l16.6-29.1-17.376,1.123-13.1,27.465a9.48,9.48,0,0,0,11.638,14.8Z",
    transform: "translate(-679.487 -197.643)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.9,531.651H772.556L769.7,483.4H786.67Z",
    transform: "translate(-531.816 -32.948)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.555,531.389l-15.851-.949V483.4H702.67Z",
    transform: "translate(-526.58 -32.948)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M828.218,451.974s-3.162,45.028,3.066,67.7,7.339,159.815,7.339,159.815H859.5L877.588,492.82,919.3,680.152l19.882-1.367-10.9-220.746Z",
    transform: "translate(-681.689 -197.726)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919.423,289.322l-15.958-11.645L876.726,283.5l-7.238,17.2-12.472,6.184a28.272,28.272,0,0,0-15.422,21.278L823.776,451.2l104.273-4.031,12.624-144.908a11.36,11.36,0,0,0-10.658-12.327Z",
    transform: "translate(-681.462 -186.86)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.76,141.253l-9.631,12.983L641.182,282.175l19.663,7.873,31.484-59.617Z",
    transform: "translate(-523.804 -11.618)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.915,
    cy: 31.915,
    r: 31.915,
    transform: "translate(171.52 22.277)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23.29,
    cy: 23.29,
    r: 23.29,
    transform: "translate(180.577 40.974)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.469,241.53c-14.83-5.349-19.848-8.635-36.228,0L863.2,217.378h48.3Z",
    transform: "translate(-683.92 -180.287)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.114,
    cy: 18.114,
    r: 18.114,
    transform: "translate(182.733 4.314)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.088,195.936a18.1,18.1,0,0,1,17.252-18.071c-.288-.014-.571-.044-.863-.044a18.114,18.114,0,1,0,0,36.228c.291,0,.575-.03.863-.044A18.1,18.1,0,0,1,863.088,195.936Z",
    transform: "translate(-683.805 -177.821)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M776.129,149.111l-6.5,64.778-22.948,45.228Z",
    transform: "translate(-530.381 -12.108)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.678,2.124V26L.186,39.424S-2.8,51.361,15.107,48.377s8.952-16.412,8.952-16.412L21.865,18.8,17.99,0Z",
    transform: "translate(158.4 485.734) rotate(16)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.376,660.348l2.983,24.738,4.092,13.616s5.353,11.789-13.745,12.1-12.38-15.29-12.38-15.29l3.913-13.487-1.66-20.311Z",
    transform: "translate(-584.993 -169.921)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 221.309)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 131.272,
    cy: 131.272,
    r: 131.272,
    transform: "translate(0.94 0.937)",
    fill: "#7C3AED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.443,390.892a32.067,32.067,0,0,1-45.349,0h0a32.073,32.073,0,0,1-4.333-39.96l-7.055,7.2a32.067,32.067,0,0,0,0,45.349h0a32.067,32.067,0,0,0,45.349,0l15.634-16.233.238-1.009Z",
    transform: "translate(-502.44 -212.223)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.372,285.541a32.067,32.067,0,0,1,44.555,8.452h0a32.073,32.073,0,0,1-3.19,40.067l8.273-5.757a32.067,32.067,0,0,0,8.452-44.555h0a32.067,32.067,0,0,0-44.555-8.452l-18.385,13.035-.422.947Z",
    transform: "translate(-507.476 -207.161)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.193,414.62a34.88,34.88,0,0,1-24.664-59.544l29.6-30.2a34.879,34.879,0,0,1,49.347-.02,2.813,2.813,0,0,1-3.978,3.978,29.254,29.254,0,0,0-41.371,0c-4.348,15.327-13.742,25.844-29.6,30.2a29.254,29.254,0,1,0,41.352,41.392c-.641-6.288,1.2-12.2,15.6-16.2a2.813,2.813,0,1,1,4.052,3.9l-15.634,16.233a34.679,34.679,0,0,1-24.7,10.254Z",
    transform: "translate(-502.253 -209.961)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.069,368.918A34.652,34.652,0,0,1,621.405,358.7a2.813,2.813,0,0,1,3.979-3.978,29.253,29.253,0,0,0,41.371,0c3.749-22.583,19.033-25.77,32.318-32.317A29.254,29.254,0,0,0,657.7,281.035c-3.7,10.662-7.324,21.45-18.331,18.331a2.813,2.813,0,0,1-3.978-3.978l18.331-18.331a34.88,34.88,0,1,1,49.327,49.327L670.732,358.7A34.651,34.651,0,0,1,646.069,368.918Z",
    transform: "translate(-506.072 -206.981)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.726,268.4a133.655,133.655,0,0,0-19.757-25.776c-1.7-1.725-3.45-3.413-5.241-5.054-.994-.909-2-1.8-3.019-2.672-1.941-1.669-3.938-3.282-5.973-4.838A131.541,131.541,0,0,0,630.669,203c-72.894,0-132.21,59.307-132.21,132.21a131.96,131.96,0,0,0,2.184,23.966.72.72,0,0,0,.019.131c.666,3.629,1.491,7.211,2.447,10.727a132.2,132.2,0,0,0,239.806,34.984q2.742-4.417,5.157-9.058A132.025,132.025,0,0,0,744.726,268.4ZM630.669,465.545A130.29,130.29,0,0,1,500.334,335.211c0-71.872,58.472-130.334,130.335-130.334a130.291,130.291,0,0,1,93.278,39.4,124.779,124.779,0,0,1,8.945,10.183,126.406,126.406,0,0,1,7.736,10.849,130.266,130.266,0,0,1,15.19,106.34c-1.153,3.975-2.5,7.867-4.023,11.683s-3.226,7.576-5.1,11.214a130.778,130.778,0,0,1-116.026,71Z",
    transform: "translate(-498.459 -203.001)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.813,
    cy: 2.813,
    r: 2.813,
    transform: "translate(83.789 129.876)",
    fill: "#7C3AED"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.813,
    cy: 2.813,
    r: 2.813,
    transform: "translate(172.867 128)",
    fill: "#7C3AED"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208.131 103.604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M893.992,466.056A9.429,9.429,0,0,1,904.4,456.021l14.288-30.308,9.061,14.869-14.957,26.5a9.48,9.48,0,0,1-18.8-1.027Z",
    transform: "translate(-893.969 -299.692)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M933.381,299.14l5.884-7.674s14.337-2.92,16.772,16.772L954.5,395.783l-31.417,49.449-20.4-5.21,26.677-58.742Z",
    transform: "translate(-894.512 -291.314)",
    fill: "#e4e4e4"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalLink);
export default __webpack_public_path__ + "static/media/goal-link.a56229b061f27cbd3dc82bf226b996b9.svg";
export { ForwardRef as ReactComponent };